import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import { useCachedByIdResource, useCachedById, useCachedByIds } from "./use-cached-by-id-resource";

const CachedPoolsContext = React.createContext();

const useCachedPoolById = id => {
  const { dataById, idsLoading, fetchIfNotCached } = React.useContext(CachedPoolsContext);

  useCachedById(id, fetchIfNotCached);

  return { pool: dataById[id] || {}, loading: idsLoading[id] };
};
const useCachedPoolsByIds = (ids = []) => {
  const { fetchIfNotCached, dataById, idsLoading, fetchById, addToCache } = React.useContext(CachedPoolsContext);
  useCachedByIds(ids, fetchIfNotCached);

  return { allPoolsById: dataById, idsLoading, fetchById, addToCache };
};

const normalize = data => {
  const ret = _.indexBy(data, "id");
  return ret;
};
const CachedPoolsProvider = ({ fetchPoolsById, children }) => {
  const value = useCachedByIdResource(pool_ids => fetchPoolsById({ pool_ids }), normalize);
  return <CachedPoolsContext.Provider value={value}>{children}</CachedPoolsContext.Provider>;
};

CachedPoolsProvider.propTypes = {
  children: PropTypes.any,
  fetchPoolsById: PropTypes.func.isRequired,
};

export { CachedPoolsProvider, useCachedPoolsByIds, useCachedPoolById };

export default CachedPoolsContext;
